import { FlexBox, useIsMobile, useScale } from "@brg/ui";
import { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { RectangularButtonFilled } from "shared/components/buttons";
import { HolderContent, ImagePreviewSection, ImagePreviewSectionImage, ImagePreviewSectionWrapper } from "shared/components/ImagePreviewSection/ImagePreviewSection";
import styled, { useTheme } from "styled-components";
import { Book, Endpoints, Project, Team } from "@brg/api";
import { getProjectImages } from "shared/pages/project/sections/ps-image";
import { useResizedImageEnhanced } from "shared/hooks/useResizedImageEnhanced";
import { ProjectCardTools } from "shared/components/projectCard/ProjectCardTools";
import { useDispatch } from "react-redux";
import { updateTeam } from "shared/actions/Teams/teamsActions";

const UploaderWrapper = styled.div`
cursor: pointer;
input {
  width: 100% !important;
  height: 100% !important;
  cursor: pointer;

  :hover {
    cursor: pointer;
  }
}
`;

const FileInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  display: block !important;
  opacity: 0;
  z-index: 1;
  cursor: pointer;
`;

const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/gif'];

export interface BookChaptersEmptyProps {
    canCreateChapter: boolean;
    onSelectChaptersClick: () => void;
    onCreateChapterClick: () => void;
    book: Book;
    previewProject?: Project;
};  

const getImages = (team: Team, lang: string) => {
    if (!team) return [];
    // const isBilingual = !!project.longreadId_en;
    // if (isBilingual) {
    //   const images = lang === 'en' ? project?.titleImages_en : project.titleImages;
    //   return images || [];
    // } else {
    //   return getProjectImages(project, lang)
    // }
    return team?.avatar;
  }

export const TeamUploadContainer: FC<{
    team: Team,
    teamId?: string;
    fileInput?: any;
    fileInputRef?: React.RefObject<HTMLInputElement>;
}> = ({
    team,
    teamId,
    //@ts-ignore
    fileInput,
    fileInputRef,
}) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isMobile = useIsMobile();
    const s = useScale();
    const dispatch = useDispatch();

    const teamAvatar = getImages(team ?? undefined, i18n.language);

    const [image, ref] = useResizedImageEnhanced(teamAvatar);

    const imageUrl = useMemo(() => {
        return (image?.url ? `${Endpoints.files}/${image.url}` : '');
      },[ref?.current, image])

    const accept = ALLOWED_FILE_TYPES.join(', ');

    return  (
        <UploaderWrapper ref={ref} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
          <FileInput 
            {...fileInput.inputProps}
            ref={fileInputRef}
            accept={accept}
          />
        </UploaderWrapper>
    );
};import { FlexBox, useIsMobile, useScale } from "@brg/ui";
import { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { RectangularButtonFilled } from "shared/components/buttons";
import { HolderContent, ImagePreviewSection, ImagePreviewSectionImage, ImagePreviewSectionWrapper } from "shared/components/ImagePreviewSection/ImagePreviewSection";
import styled, { useTheme } from "styled-components";
import { Book, Endpoints, Project, Team } from "@brg/api";
import { getProjectImages } from "shared/pages/project/sections/ps-image";
import { useResizedImageEnhanced } from "shared/hooks/useResizedImageEnhanced";
import { ProjectCardTools } from "shared/components/projectCard/ProjectCardTools";
import { useDispatch } from "react-redux";
import { updateTeam } from "shared/actions/Teams/teamsActions";

const UploaderWrapper = styled.div`
cursor: pointer;
input {
  width: 100% !important;
  height: 100% !important;
  cursor: pointer;

  :hover {
    cursor: pointer;
  }
}
`;

const FileInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  display: block !important;
  opacity: 0;
  z-index: 1;
  cursor: pointer;
`;

const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/gif'];

export interface BookChaptersEmptyProps {
    canCreateChapter: boolean;
    onSelectChaptersClick: () => void;
    onCreateChapterClick: () => void;
    book: Book;
    previewProject?: Project;
};  

const getImages = (team: Team, lang: string) => {
    if (!team) return [];
    // const isBilingual = !!project.longreadId_en;
    // if (isBilingual) {
    //   const images = lang === 'en' ? project?.titleImages_en : project.titleImages;
    //   return images || [];
    // } else {
    //   return getProjectImages(project, lang)
    // }
    return team?.avatar;
  }

export const TeamUploadContainer: FC<{
    team: Team,
    teamId?: string;
    fileInput?: any;
    fileInputRef?: React.RefObject<HTMLInputElement>;
}> = ({
    team,
    teamId,
    //@ts-ignore
    fileInput,
    fileInputRef,
}) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isMobile = useIsMobile();
    const s = useScale();
    const dispatch = useDispatch();

    const teamAvatar = getImages(team ?? undefined, i18n.language);

    const [image, ref] = useResizedImageEnhanced(teamAvatar);

    const imageUrl = useMemo(() => {
        return (image?.url ? `${Endpoints.files}/${image.url}` : '');
      },[ref?.current, image])

    const accept = ALLOWED_FILE_TYPES.join(', ');

    return  (
        <UploaderWrapper ref={ref} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
          <FileInput 
            {...fileInput.inputProps}
            ref={fileInputRef}
            accept={accept}
          />
        </UploaderWrapper>
    );
};